import React from 'react';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import './Sort.css'


class Sort extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      sortedBy : ''
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = event => {
    this.setState({
      sortedBy: event.target.value
    })
    this.props.setSort(event.target.value);
  };

  render(){
      return(
        <div className="sortFilter">
          <FormControl >
            <InputLabel id="sortFilter">Sort By</InputLabel>
            <Select
              className = "sortingfilter"
              labelId="sortFilter"
              id="sortFilter"
              value={this.state.sortedBy}
              onChange={this.handleChange}
            >
              <MenuItem value={'None'}>Original</MenuItem>
              <MenuItem value={'HightoLow'}>High to Low</MenuItem>
              <MenuItem value={'LowtoHigh'}>Low to High</MenuItem>
            </Select>
          </FormControl>
          
        </div>
      ) 
  }

}export default Sort;